<template>
  <pf-content v-bind="ouiaProps">
    <template v-if="variant === 'list'">{{ label }}: </template>
    <s v-if="prezzo != prezzo_scontato">
      {{ $currency(prezzo, wizard.customer?.currency) }}
    </s>
    {{ ' ' }}
    <component :is="variant === 'list' ? 'strong' : 'span'">
      {{ $currency(prezzo_scontato, wizard.customer?.currency) }}
    </component>
    <component :is="variant === 'list' ? 'span' : 'div'" class="vat">
      <template v-if="wizard.customer === undefined || wizard.customer.vat > 0"> + {{ $t('IVA') }}</template
      ><template v-if="product?.durata"> / {{ $t(product.durata) }}</template>
    </component>
    <p v-if="product?.categoria === 'Internet Domain — Other TLD'" class="pf-v6-u-mt-sm">
      <triangle-exclamation-icon />
      {{
        $t(
          'In caso di domini classificati come premium, il costo di registrazione potrebbe essere superiore rispetto alle tariffe standard. In questi casi, la registrazione verrà preventivamente quotata e attivata solo previa conferma.',
        )
      }}
    </p>
  </pf-content>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { $t as _t } from '@/i18n';
import { useWizard, type ProductPriceInfo } from '@/wizard';
import { useOUIAProps, type OUIAProps } from '@common/ouia';
import { TriangleExclamationIcon } from '@vue-patternfly/icons';

defineOptions({
  name: 'WizardPriceTag',
});

interface Props extends OUIAProps {
  product?: ProductPriceInfo;
  productInstead?: ProductPriceInfo;
  variant?: 'table' | 'list';
  label?: string;
  qt?: number;
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'list',
  label: _t('Prezzo'),
  qt: 1,
});

const ouiaProps = useOUIAProps(props);
const wizard = useWizard();

const prezzo = computed(() => {
  if (!props.productInstead) {
    return props.product ? props.product.prezzo * props.qt : 0;
  }

  return props.product ? (props.product.prezzo - props.productInstead.prezzo) * props.qt : 0;
});

const prezzo_scontato = computed(() => {
  if (!props.productInstead) {
    return props.product ? props.product.prezzo_scontato * props.qt : 0;
  }

  return props.product ? (props.product.prezzo_scontato - props.productInstead.prezzo_scontato) * props.qt : 0;
});
</script>
